export const config = {
  API_BUSINESS: process.env.REACT_APP_API_BUSINESS,
  API_SSO: process.env.REACT_APP_API_SSO,
  API_BOOKING: process.env.REACT_APP_API_BOOKING,
  API_CONTENT: process.env.REACT_APP_API_CONTENT,
  API_NOTIFICATION: process.env.REACT_APP_API_NOTIFICATION,
  REFRESH_TOKEN_WAIT_TIME: process.env.REACT_APP_REFRESH_TOKEN_WAIT_TIME,
};
